import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
   * {
      box-sizing: border-box;
   }
   padding: 2rem 0;
   width: 100%;
   max-width: 1100px;
   margin: 0 auto;
   text-align: left;
`

export const AppWrapper = ({ children }) => (
   <Wrapper className="App">{children} </Wrapper>
)
